<script lang="ts">
	let {
		unitDescription = "No description provided for this unit."
	}: { unitDescription?: string | null } = $props();
</script>

<!-- Unit Description -->
<div id="unit-description" class="mb-8">
	<h2 class="mb-4 text-2xl font-bold">About the Unit</h2>
	<p class="text-gray-700">
		{unitDescription}
	</p>
</div>
